// extracted by mini-css-extract-plugin
module.exports = {"starschemaLoader":"TopLoader_starschemaLoader__1XAUk"};